<template>
    <el-footer style="height: 94px;margin-bottom: 30px;margin-top: 30px;">
        <div>
            <img src="../assets/images/address.png"/>
        </div>
        <div style="height:30px; line-height:30px; font-size: 14px; color: #ffffff;">
            地址: 重庆市金开大道106号互联网产业园4号楼6楼
        </div>
        <div style="height:30px; line-height:30px; font-size: 12px; color: #ffffff;">
            美天科技版权所有 Copyright@2015 Meitian Corporation, All Rights Reserv <a href="http://beian.miit.gov.cn" target="blank" style="color:#ffffff;text-decoration:none;">渝ICP备09061737号-4</a>
        </div>
    </el-footer>
</template>

<script>
    export default {
        name: "footer-meitq"
    }
</script>

<style scoped lang="less">
    .el-footer{
        div{
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footerMei.vue